import { LOCALE_ID, Provider } from '@angular/core';

export const provideLocaleId = (): Provider => {
  return {
    provide: LOCALE_ID,
    useValue: 'main'
  };
};
